const INCODE_SDK_SERVICE_WORKER_URL = '/incode-sdk-sw.js';

/**
 * Registers the Incode SDK cache-first service worker. Registration is
 * deferred to the window `load` event so it never competes with the current
 * page's own critical resources — the payoff is a later liveness attempt
 * (new tab, new session) loading the SDK script from CacheStorage instead
 * of the network. A registration failure is swallowed: this is a pure
 * performance optimization and must never affect the liveness flow itself.
 */
export function registerIncodeSdkServiceWorker(): void {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;

    window.addEventListener('load', () => {
        navigator.serviceWorker.register(INCODE_SDK_SERVICE_WORKER_URL).catch(() => {
            // Intentionally silent — see doc comment above.
        });
    });
}
